import api from './api'
import type { StatusRegistryPayload } from '@/types/statusRegistry.types'
import { loggerService, toLoggableError } from './logger.service'

const BASE_URL = '/api/v1/meta'

/**
 * Fetch the unified status registry from the backend.
 * Returns null on failure (caller should use fallback vocabulary).
 */
export async function fetchStatuses(): Promise<StatusRegistryPayload | null> {
  try {
    const response = await api.get<StatusRegistryPayload>(`${BASE_URL}/statuses`)
    return response.data
  } catch (err) {
    void loggerService.logError(toLoggableError(err), { action: 'meta_statuses_fetch' })
    return null
  }
}